export const MODAL_TYPE_MOVE_POST = 'move-post';
